var map = {
	"./IMG_20250111_112127.png": 91,
	"./Partner-_CLA_-_Programming_Essentials_in_C_certificate_22mh1a42e7-acoe-edu-in_e5830049-8fb8-4119-bcd8-b819e7b4e6fa.pdf": 92,
	"./Programming_Essentials_in_C.png": 93,
	"./Programming_Essentials_in_Python.pdf": 94,
	"./Programming_Essentials_in_Python.png": 95,
	"./address_image.svg": 96,
	"./aditya_logo.png": 97,
	"./ai-technology.png": 98,
	"./ai.png": 99,
	"./animated_ashutosh.png": 100,
	"./animated_logo.svg": 101,
	"./ba_contact_me.png": 102,
	"./blogs_image.svg": 103,
	"./certificate_icon.svg": 104,
	"./checklist-svgrepo-com.svg": 105,
	"./cloud_infrastructure.svg": 106,
	"./codeInLogo.png": 107,
	"./contactMail.png": 108,
	"./contact_me.png": 109,
	"./contact_me1.png": 110,
	"./coursera_logo.png": 111,
	"./data_science.svg": 112,
	"./deeplearning_ai_logo.png": 113,
	"./delhivery_logo.png": 114,
	"./developerActivity.svg": 115,
	"./dsc_logo.png": 116,
	"./education.svg": 117,
	"./experience.svg": 118,
	"./feelingProud.svg": 119,
	"./freecopy_logo.png": 120,
	"./fullstack.svg": 121,
	"./gcp_logo.png": 122,
	"./github_logo.png": 123,
	"./googleAssistant.jpg": 124,
	"./googleAssistant.svg": 125,
	"./google_logo.png": 126,
	"./hackerrank_logo.png": 127,
	"./ibm_logo.png": 128,
	"./iiitk_logo.png": 129,
	"./intel_logo.jpg": 130,
	"./it-specialist-html-and-css.png": 131,
	"./it-specialist-java.png": 132,
	"./iu_logo.png": 133,
	"./jsFramework.svg": 134,
	"./jse1.png": 135,
	"./jse2.png": 136,
	"./landing image logo.png": 137,
	"./landing image.png": 138,
	"./legato_logo.png": 139,
	"./manOnTable.svg": 140,
	"./microsoft_logo.png": 141,
	"./mozilla_logo.png": 142,
	"./muffito_logo.png": 143,
	"./netacad_logo_black.svg": 144,
	"./nextuLogo.jpg": 145,
	"./nptel_logo.png": 146,
	"./portfolio.gif": 147,
	"./programmer.svg": 148,
	"./projects_image.svg": 149,
	"./pwa.png": 150,
	"./saayaHealthLogo.png": 151,
	"./spjc_logo.gif": 152,
	"./stanford_logo.png": 153,
	"./svg/Anaconda.svg": 154,
	"./svg/Apache-Maven.svg": 155,
	"./svg/Apache-Tomcat.svg": 156,
	"./svg/Bootstrap.svg": 157,
	"./svg/C++-(CPlusPlus).svg": 158,
	"./svg/C.svg": 159,
	"./svg/CSS3.png": 160,
	"./svg/Docker.svg": 161,
	"./svg/Figma.svg": 162,
	"./svg/Firebase.svg": 163,
	"./svg/GitHub.svg": 164,
	"./svg/HTML5.svg": 165,
	"./svg/JavaScript.svg": 166,
	"./svg/Jira.svg": 167,
	"./svg/MongoDB.svg": 168,
	"./svg/MySQL.svg": 169,
	"./svg/NPM.svg": 170,
	"./svg/Next.js.svg": 171,
	"./svg/Node.js.svg": 172,
	"./svg/Nodemon.svg": 173,
	"./svg/NumPy.svg": 174,
	"./svg/OpenCV.svg": 175,
	"./svg/Pandas.svg": 176,
	"./svg/PostgresSQL.svg": 177,
	"./svg/Postman.svg": 178,
	"./svg/PyTorch.svg": 179,
	"./svg/Python.svg": 180,
	"./svg/React.svg": 181,
	"./svg/Socket.io.svg": 182,
	"./svg/Spring.svg": 183,
	"./svg/Tailwind-CSS.svg": 184,
	"./svg/TensorFlow.svg": 185,
	"./svg/TypeScript.svg": 186,
	"./svg/Visual-Studio-Code-(VS-Code).svg": 187,
	"./svg/Vite.js.svg": 188,
	"./talksCardBack.svg": 189,
	"./talksCardBackAlt.svg": 190,
	"./thub_logo.jpg": 191,
	"./thub_logo.png": 192,
	"./thublogo.png": 193,
	"./tiktok_logo.png": 194,
	"./ui_ux_design.svg": 195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;